import { TextInput } from 'flowbite-react';
import React, { useState } from 'react';
import { Button, Card, CheckboxGroup, LoadingSpinner } from '../components';
import { AllLanguages, LoadingSpinnerMeta, SignupMeta } from '../data';
import { EyeHideIcon, EyeIcon } from '../icons';
import { generateCSID } from '../utils/volunteers';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000/api';

const PASSWORD_MIN_LENGTH = 8

function Signup() {
    const meta = SignupMeta
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState<string | null>(null)
    const [success, setSuccess] = useState(null);

    // const [availablePreferences, setAvailablePreferences] = useState<Preference[]>([])
    // const [selectedPreferences, setSelectedPreferences] = useState<number[]>([])
    // const [availableFlags, setAvailableFlags] = useState<Flag[]>([])
    // const [selectedFlags, setSelectedFlags] = useState<number[]>([])
    const [selectedLanguages, setSelectedLanguages] = useState<string[]>([])

    const [showPassword, setShowPassword] = useState(false);

    const [showRePassword, setShowRePassword] = useState(false);


    const [formData, setFormData] = useState({
        email: "",
        password: "",
        re_password: "",
        first_name: "",
        last_name: "",
        country_code: "",
        gender: '',
        dob: '',
        phone: '',
        country: '',
        jamat_khana: '',
        support_needs: '',
        ismaili: null,
        multi_faith_family: null,
        family_origin: '',
    });


    // useEffect(() => {
    //     const fetchPreferences = async () => {
    //         try {
    //             const response = await fetch(`${API_BASE_URL}/preference`, {
    //                 credentials: 'include'
    //             })
    //             if (response.ok) {
    //                 const result = await response.json()
    //                 let data = result.value || result
    //                 if (Array.isArray(data) && data.length > 0 && Array.isArray(data[0])) {
    //                     data = data[0]
    //                 }
    //                 setAvailablePreferences(Array.isArray(data) ? data : [])
    //             }
    //         } catch (err) {
    //             console.error('Failed to fetch preferences:', err)
    //         }
    //     }

    //     const fetchFlags = async () => {
    //         try {
    //             const response = await fetch(`${API_BASE_URL}/flag`, {
    //                 credentials: 'include'
    //             })
    //             if (response.ok) {
    //                 const result = await response.json()
    //                 let data = result.value || result
    //                 if (Array.isArray(data) && data.length > 0 && Array.isArray(data[0])) {
    //                     data = data[0]
    //                 }
    //                 setAvailableFlags(Array.isArray(data) ? data : [])
    //             }
    //         } catch (err) {
    //             console.error('Failed to fetch flags:', err)
    //         }
    //     }

    //     fetchPreferences();
    //     fetchFlags();
    // }, [])


    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };


    const handleCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, checked } = e.target
        setFormData(prev => ({ ...prev, [name]: checked }))
    }

    const handleFaithStatusChange = (value: 'ismaili' | 'multi_faith_family') => {
        setFormData(prev => ({
            ...prev,
            ismaili: value === 'ismaili' ? true : false,
            multi_faith_family: value === 'multi_faith_family' ? true : false
        }))
    }

    // const handlePreferenceToggle = (preferenceId: number) => {
    //     setSelectedPreferences(prev => {
    //         if (prev.includes(preferenceId)) {
    //             return prev.filter(id => id !== preferenceId)
    //         } else {
    //             return [...prev, preferenceId]
    //         }
    //     })
    // }

    // const handleFlagToggle = (flagId: number) => {
    //     setSelectedFlags(prev => {
    //         if (prev.includes(flagId)) {
    //             return prev.filter(id => id !== flagId)
    //         } else {
    //             return [...prev, flagId]
    //         }
    //     })
    // }



    const certificationOptions = [
        { value: "Doctor", label: "Doctor" },
        { value: "Nurse", label: "Nurse" },
        { value: "First Aid", label: "First Aid" },
        { value: "Police", label: "Police" },
        { value: "Fire Marshall", label: "Fire Marshall" },
        { value: "SIA Security", label: "SIA Security" },
    ];

    const allLanguages = AllLanguages;

    const allCountries = [
        "United States", "India", "China", "Brazil", "Russia", "Germany",
        "United Kingdom", "France", "Japan", "Canada", "Australia", "Mexico",
        "Pakistan", "Bangladesh", "Nigeria", "Indonesia", "South Korea", "Other"
    ];

    const regexCheck = (value: string, regExp: RegExp) => {
        return regExp.test(value);
    }

    const handleLanguageToggle = (language: string) => {
        setSelectedLanguages(prev => {
            if (prev.includes(language)) {
                return prev.filter(lang => lang !== language)
            } else {
                return [...prev, language]
            }
        })
    }

    const getAgeFromDOB = (dob: string): number | null => {
        const AGE_AT_DATE = new Date('2026-02-04');
        const dobDate = new Date(dob);
        if (!isNaN(dobDate.getTime())) {
            const today = AGE_AT_DATE;
            let years = today.getFullYear() - dobDate.getFullYear();

            if (
                today.getMonth() < dobDate.getMonth() ||
                (today.getMonth() === dobDate.getMonth() && today.getDate() < dobDate.getDate())
            ) {
                years--;
            }

            if (years >= 0) return years;
        }
        return null;
    }



    const handleSubmit = async (e) => {
        e.preventDefault();
        setError(null);
        setLoading(true);
        setSuccess(null);

        // Handle password checking
        if (formData.password !== formData.re_password) {
            setError(meta.passwordsDoNotMatch);
            setLoading(false);
            return;
        }

        // Validate that at least one faith status is selected
        if (formData.ismaili === null && formData.multi_faith_family === null) {
            setError(meta.faithStatusRequired);
            setLoading(false);
            return;
        }

        // Validate date of birth results in a valid age
        const calculatedAge = getAgeFromDOB(formData.dob);
        if (calculatedAge === null) {
            setError(meta.invalidDob);
            setLoading(false);
            return;
        }

        const signupData = {
            volunteer_csid: generateCSID(), // Generate a volunteer csid based on timestamp
            email: formData.email,
            password: formData.password,
            first_name: formData.first_name,
            last_name: formData.last_name,
            country_code: formData.country_code,
            gender: formData.gender,
            dob: formData.dob,
            age: calculatedAge,
            phone: formData.phone,
            country: formData.country,
            jamat_khana: formData.jamat_khana,
            language: selectedLanguages.join(', '),
            support_needs: formData.support_needs,
            ismaili: formData.ismaili,
            multi_faith_family: formData.multi_faith_family,
            family_origin: formData.family_origin,
        };

        try {
            const response = await fetch(API_BASE_URL + '/auth/signup',
                {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json',
                        'X-Requested-With': 'XMLHttpRequest'
                    },
                    credentials: 'include',
                    body: JSON.stringify(signupData)
                });

            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.message || 'Signup failed.');
            }

            const data = await response.json();
            console.log("Signup Successful:", data);
            setSuccess(data.message || 'Registration successful. Please check your email to verify your account.');



        } catch (e) {
            // Catch network errors or errors thrown above
            setError(e.message || 'An unexpected error occurred during signup.');
        } finally {
            setLoading(false);
        }
    };


    return (
        <div className="bg-[url(/public/header_tile_gold.png)] bg-tile text-white flex flex-col items-center justify-center min-h-screen py-12 px-4 w-full">
            <Card className="w-full max-w-3xl text-gray-900 dark:text-white p-4">
                <div>
                    {loading && (
                        <div className="flex justify-center items-center mb-4 min-h-[40px]">
                            <LoadingSpinner meta={LoadingSpinnerMeta} />
                        </div>
                    )}

                    {(error || success) && (
                        <div className={`mb-4 rounded-lg p-4 text-sm ${error
                            ? 'bg-danger-500/10 text-danger-500 border-danger-500 border'
                            : 'bg-success-500/10 text-success-500 border-success-500 border'
                            }`}>
                            {error || success}
                        </div>
                    )}
                    {success !== null ? (
                        <div className="text-center py-8 px-4">
                            <div className="max-w-md mx-auto space-y-4">
                                <h3 className="text-xl font-semibold text-gray-800 dark:text-gray-200">
                                    {meta.checkEmailTitle}
                                </h3>
                                <p className="text-gray-600 dark:text-gray-400">
                                    {meta.checkEmailMessage}
                                </p>
                                <div className="bg-primary-50 dark:bg-primary-900/20 rounded-lg p-4 text-start">
                                    <p className="text-sm text-gray-600 dark:text-gray-400">
                                        <strong className="font-medium">{meta.checkEmailHint}</strong>
                                    </p>
                                </div>
                            </div>
                        </div>
                    ) : (
                        <form onSubmit={handleSubmit} className="space-y-8">
                            {/* Account Info */}
                            <section>
                                <div className='mb-4 border-b-2 dark:border-gray-600'>
                                    <div className='flex items-start gap-3 mb-4'>
                                        <span className="flex-shrink-0 w-6 h-6 rounded-full bg-primary-100 dark:bg-primary-900/30 flex items-center justify-center">
                                            <span className="text-primary-600 dark:text-primary-400 font-bold text-sm">!</span>
                                        </span>
                                        <p className="text-sm text-gray-500 dark:text-gray-400">
                                            {meta.travelInfo}
                                        </p>
                                    </div>
                                </div>
                                <h3 className="text-lg font-semibold text-gray-800 dark:text-gray-200 mb-4">
                                    {meta.accountInfoTitle}
                                </h3>
                                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                    <div className="md:col-span-2">
                                        <TextInput
                                            type="email"
                                            name="email"
                                            placeholder={meta.emailPlaceholder}
                                            value={formData.email}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>

                                    {/* Password Field */}
                                    <div className='relative'>
                                        <TextInput
                                            type={showPassword ? "text" : "password"}
                                            name="password"
                                            placeholder={meta.passwordPlaceholder}
                                            value={formData.password}
                                            onChange={handleChange}
                                            minLength={PASSWORD_MIN_LENGTH}
                                            required

                                        />
                                        <Button
                                            variant='icon'
                                            className='absolute end-2 top-1/2 -translate-y-1/2'
                                            type="button"
                                            onClick={() => setShowPassword(!showPassword)}
                                        >
                                            {!showPassword ? <EyeIcon /> : <EyeHideIcon />}
                                        </Button>
                                    </div>

                                    <div className='relative'>
                                        <TextInput
                                            type={showRePassword ? "text" : "password"}
                                            name="re_password"
                                            placeholder={meta.rePasswordPlaceholder}
                                            value={formData.re_password}
                                            onChange={handleChange}
                                            minLength={PASSWORD_MIN_LENGTH}
                                            required
                                        />
                                        <Button
                                            variant='icon'
                                            className='absolute end-2 top-1/2 -translate-y-1/2'
                                            type="button"
                                            onClick={() => setShowRePassword(!showRePassword)}
                                        >
                                            {!showRePassword ? <EyeIcon /> : <EyeHideIcon />}
                                        </Button>
                                    </div>
                                </div>
                            </section>
                            {/* Personal Info */}
                            <section>
                                <h3 className="text-lg font-semibold text-gray-800 dark:text-gray-200 mb-4">
                                    {meta.volunteerInfoTitle}
                                </h3>
                                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                    <TextInput
                                        name="first_name"
                                        placeholder={meta.firstNamePlaceholder}
                                        value={formData.first_name}
                                        onChange={handleChange}
                                        required
                                    />
                                    <TextInput
                                        name="last_name"
                                        placeholder={meta.lastNamePlaceholder}
                                        value={formData.last_name}
                                        onChange={handleChange}
                                        required
                                    />
                                    <select
                                        name="gender"
                                        value={formData.gender}
                                        onChange={handleChange}
                                        required
                                        className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-primary-500 dark:bg-gray-700 bg-gray-50 dark:text-gray-100 disabled:opacity-50"
                                    >
                                        <option value="">{meta.selectGender}</option>
                                        <option>{meta.male}</option>
                                        <option>{meta.female}</option>
                                        <option>{meta.preferNotToSay}</option>
                                    </select>
                                    <input
                                        type="date"
                                        name="dob"
                                        value={formData.dob}
                                        onChange={handleChange}
                                        required
                                        className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-primary-500 dark:bg-gray-700 bg-gray-50 dark:text-gray-100 disabled:opacity-50"
                                    />
                                </div>
                                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">
                                    <TextInput
                                        name="country_code"
                                        placeholder={meta.countryCodePlaceholder}
                                        value={formData.country_code}
                                        onChange={handleChange}
                                        required
                                    />
                                    <TextInput
                                        name="phone"
                                        placeholder={meta.phonePlaceholder}
                                        value={formData.phone}
                                        onChange={handleChange}
                                        required
                                    />
                                    <TextInput
                                        name="country"
                                        placeholder={meta.countryPlaceholder}
                                        value={formData.country}
                                        onChange={handleChange}
                                        required
                                    />
                                    <TextInput
                                        name="jamat_khana"
                                        placeholder={meta.jamatkhanaPlaceholder}
                                        value={formData.jamat_khana}
                                        onChange={handleChange}
                                    />
                                    <div>
                                        <label
                                            htmlFor="family_origin"
                                            className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1"
                                        >
                                            {meta.familyOriginLabel}
                                        </label>
                                        <select
                                            id="family_origin"
                                            name="family_origin"
                                            value={formData.family_origin}
                                            onChange={handleChange}
                                            required
                                            className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-primary-500 dark:bg-gray-700 bg-gray-50 dark:text-gray-100 disabled:opacity-50"
                                        >
                                            <option value="">{meta.selectOrigin}</option>
                                            <option value="East Africa">East Africa</option>
                                            <option value="Indian Subcontinent">Indian Subcontinent (India / Pakistan / Bangladesh)</option>
                                            <option value="Afghanistan">Afghanistan</option>
                                            <option value="Tajikistan">Tajikistan</option>
                                            <option value="Syria">Syria</option>
                                            <option value="Iran">Iran</option>
                                            <option value="Mixed Origin">Mixed Origin</option>
                                            <option value="Other">Other</option>
                                        </select>

                                    </div>

                                </div>
                            </section>

                            {/* ... Rest of your form (Contact Details, Identity, Flags) remains exactly the same ... */}


                            {/* Identity, Flags, Support Needs */}
                            <section>
                                <h3 className="text-lg font-semibold text-gray-800 dark:text-gray-200 mb-4">
                                    {meta.additionalDetailsTitle} <span className="text-danger-600">*</span>
                                </h3>
                                <div className="flex gap-6">
                                    <label className="flex items-center gap-2 cursor-pointer">
                                        <input
                                            type="radio"
                                            name="faith_status"
                                            checked={formData.ismaili === true}
                                            onChange={() => handleFaithStatusChange('ismaili')}
                                            className="cursor-pointer"
                                        />
                                        {meta.ismaili}
                                    </label>
                                    <label className="flex items-center gap-2 cursor-pointer">
                                        <input
                                            type="radio"
                                            name="faith_status"
                                            checked={formData.multi_faith_family === true}
                                            onChange={() => handleFaithStatusChange('multi_faith_family')}
                                            className="cursor-pointer"
                                        />
                                        {meta.interFaithFamily}
                                    </label>
                                </div>
                            </section>

                            <section className="space-y-6">
                                {/* <CheckboxGroup
                            label="Additional Skills"
                            options={availableFlags.map(f => ({ id: f.id, label: f.name }))}
                            selectedValues={selectedFlags}
                            onChange={handleFlagToggle}
                            columns={3}
                        />

                        <CheckboxGroup
                            label="Preferences"
                            options={availablePreferences.map(p => ({ id: p.id, label: p.name }))}
                            selectedValues={selectedPreferences}
                            onChange={handlePreferenceToggle}
                            columns={3}
                        /> */}

                                <CheckboxGroup
                                    label={meta.languagesLabel}
                                    options={allLanguages.map(l => ({ id: l, label: l }))}
                                    selectedValues={selectedLanguages}
                                    onChange={handleLanguageToggle}
                                    columns={3}
                                />
                            </section>

                            <section>
                                <textarea
                                    name="support_needs"
                                    rows={3}
                                    value={formData.support_needs}
                                    onChange={handleChange}
                                    className="w-full border rounded-md border-gray-300 dark:bg-gray-700 dark:border-gray-600 p-2"
                                    placeholder={meta.supportNeedsPlaceholder}
                                />
                            </section>

                            <div className="pt-4 border-t dark:border-gray-600 flex justify-end">
                                <Button type="submit" disabled={loading}>
                                    {loading ? meta.registering : meta.registerButton}
                                </Button>
                            </div>

                        </form>
                    )}
                </div>
            </Card>
        </div>
    );

}
export default Signup;

